import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dhd-list-tile',
  templateUrl: './dhd-list-tile.component.html',
  styleUrls: ['./dhd-list-tile.component.scss']
})
export class DhdListTileComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
